/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, Vue} from 'vue-property-decorator'
import {formatDate} from '@/utils/timeFilter'
import {getDownloadFinanceContractById} from '@/api/financial-center'
import {menuBtn} from '@/utils/menu_level2_button'
import {getMessageRemindById} from "@/api/message";


@Component({})
export default class ContractMsg extends Vue {
    logShow = true
    contractId = NaN
    contractInfo = null
    status = ''
    isUpdatedData = '0'
    activities = []
    fileTypeslist: any = [
        {name: '学生合同', val: '0'},
        {name: '代理合同', val: '1'},
        {name: '高校合同', val: '2'}
    ]
    downloadUrl = ''
    directorDepartmentlName = ''
    contractCode = ''
    isShow = ''
    contractTypes = ''

    menuBtn = menuBtn
    formatDate = formatDate

    created() {
        //  获取地址栏里的参数
        const url = window.location.href
        const p = url.split('?')[1]
        const params = new URLSearchParams(p)
        const recordId = params.get('id')
        this.contractTypes = params.get('financeContractTypes')
        this.getMsgData(recordId)
    }


    async getMsgData(id) {
        const data: any = await getMessageRemindById({id: id})
        this.contractInfo = data.result.messageRemindInfo
        this.contractInfo.contractAt = this.contractInfo.contractAt.replace(/&/g, ",");
        this.downloadUrl = this.contractInfo.downloadUrl
        this.contractCode = this.contractInfo.code
        this.isShow = this.contractInfo.isShow
        this.contractId = this.contractInfo.id
    }


    // 预览
    previewContract() {
        window.open(this.downloadUrl, 'blank')
    }

    previewContractUrl() {
        window.open(this.contractInfo.url, 'blank')
    }

    // 查询签署结果
    queryResult() {
        getDownloadFinanceContractById({
            id: this.contractId
        })
    }



}
